import { render, staticRenderFns } from "./Novidades.vue?vue&type=template&id=e0ebfa08"
import script from "./Novidades.vue?vue&type=script&lang=js"
export * from "./Novidades.vue?vue&type=script&lang=js"
import style0 from "./Novidades.vue?vue&type=style&index=0&id=e0ebfa08&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports